import { Greyscale, SecondaryColor } from 'glints-aries';
import styled from 'styled-components';

export const ModalContainer = styled.div`
  background: transparent;
  display: flex;
  flex-direction: column;
  text-align: center;

  img {
    margin-bottom: 25px;
  }

  h1 {
    margin-bottom: 0;
    margin-top: 0;
    font-size: 16px;
    font-weight: bold;
  }

  p {
    margin-top: 20px;
    margin-bottom: 17px;
    font-size: 14px;
  }

  form {
    margin-bottom: 28px;
  }

  a {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const ModalFormWrapper = styled.div`
  display: flex;

  > div {
    width: 100%;
  }

  input {
    flex-grow: 1;
  }

  span {
    left: 0;
  }

  button {
    font-size: 16px;
    padding: 9px 26px;
    background: ${SecondaryColor.actionblue};
    color: ${Greyscale.white};
    border: none;
  }
`;

export const WhatsAppBanner = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #f3fbfe;
  padding: 16px;

  svg {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
  }
`;
